// extracted by mini-css-extract-plugin
export default {"panel":"SubpageSelection_panel__rBhrs","buttonToSubPages":"SubpageSelection_buttonToSubPages__zf-T7","active":"SubpageSelection_active__JFBYq"};